import {Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import React from "react";
import {
    conaceBoieresti, istanbul,
    maramuresWinterTraditions,
    prislop,
    taraFagarasului,
    toplita,
    tuberoze
} from "../trips/seniorTrips";
import TripWithPhotosComponent from "../trips/TripWithPhotosComponent";

const Senior = () => {
    return (
        <Stack direction="column" padding="40px" gap="40px">
            {/*Excursii de o zi*/}
            <Stack direction={{xs: 'column', md: 'row'}} gap="20px" justifyContent="center">
                <Stack direction="column" gap="20px">
                    <Typography variant="h4">
                        Excursii de o zi
                    </Typography>
                    <Stack direction="column" gap="50px">
                        <TripWithPhotosComponent trip={prislop}/>
                        <TripWithPhotosComponent trip={conaceBoieresti}/>
                        <TripWithPhotosComponent trip={taraFagarasului}/>
                        <TripWithPhotosComponent trip={toplita}/>
                        <TripWithPhotosComponent trip={tuberoze}/>
                    </Stack>
                </Stack>
            </Stack>
            {/*Excursii de mai multe zile*/}
            <Stack direction={{xs: 'column', md: 'row'}} gap="20px" justifyContent="center">
                <Stack direction="column" gap="20px">
                    <Typography variant="h4">
                        Excursii de mai multe zile
                    </Typography>
                    <Stack direction="column" gap="50px">
                        <TripWithPhotosComponent trip={istanbul}/>
                        <TripWithPhotosComponent trip={maramuresWinterTraditions}/>
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    )
}

export default Senior;